var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item"},[_c('vue-crumbs'),_c('vue-item'),_c('vue-card'),_c('vue-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }